import { render, staticRenderFns } from "./BynderMetadataModal.vue?vue&type=template&id=69bcf3b5"
import script from "./BynderMetadataModal.vue?vue&type=script&lang=js"
export * from "./BynderMetadataModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69bcf3b5')) {
      api.createRecord('69bcf3b5', component.options)
    } else {
      api.reload('69bcf3b5', component.options)
    }
    module.hot.accept("./BynderMetadataModal.vue?vue&type=template&id=69bcf3b5", function () {
      api.rerender('69bcf3b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modals/BynderMetadataModal.vue"
export default component.exports